export default "__VITE_ASSET__CejCDYSG__"